export const LocationIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M9.99999 11.8083C8.22499 11.8083 6.77499 10.3667 6.77499 8.58334C6.77499 6.8 8.22499 5.36667 9.99999 5.36667C11.775 5.36667 13.225 6.80834 13.225 8.59167C13.225 10.375 11.775 11.8083 9.99999 11.8083ZM9.99999 6.61667C8.91666 6.61667 8.02499 7.5 8.02499 8.59167C8.02499 9.68334 8.90833 10.5667 9.99999 10.5667C11.0917 10.5667 11.975 9.68334 11.975 8.59167C11.975 7.5 11.0833 6.61667 9.99999 6.61667Z"
				fill="white"
			/>
			<path
				d="M9.99999 18.9667C8.76666 18.9667 7.52499 18.5 6.55833 17.575C4.09999 15.2083 1.38333 11.4333 2.40833 6.94167C3.33333 2.86667 6.89166 1.04167 9.99999 1.04167C9.99999 1.04167 10 1.04167 10.0083 1.04167C13.1167 1.04167 16.675 2.86667 17.6 6.95C18.6167 11.4417 15.9 15.2083 13.4417 17.575C12.475 18.5 11.2333 18.9667 9.99999 18.9667ZM9.99999 2.29167C7.57499 2.29167 4.45833 3.58333 3.63333 7.21667C2.73333 11.1417 5.19999 14.525 7.43333 16.6667C8.87499 18.0583 11.1333 18.0583 12.575 16.6667C14.8 14.525 17.2667 11.1417 16.3833 7.21667C15.55 3.58333 12.425 2.29167 9.99999 2.29167Z"
				fill="white"
			/>
		</svg>
	)
}
